// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2EpaG","toggleWrap":"styles_toggleWrap__3yV2Z","content":"styles_content__X0ByK","selectAreaCode":"styles_selectAreaCode__2G5lh"};